import { axiosNTL, axiosNT } from '../../../services/axios';
import axios from '../../../services/axios';
import { contentManagementService } from '../../course-Management/service';


const getCourseData = (filterString: string) => axiosNT
  .get(`/package/listPackage?${filterString}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

  const getResponseSheet = (id: any) => {
    return axiosNTL.get(`/bulk-operation/report-info/${id}`)
    .then((res:any)=> Promise.resolve(res));
}

const getAllCourses = () => axiosNTL
  .get(`/course/getAllCourses`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const getCourseDetail = (courseId: string) => axiosNTL
  .get(`/package/getPackageBasicInfo/${courseId}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const getCourseChapters = (courseId: string, chaptersString: string, search: string, isSubMilestones : number = 0) => axiosNTL
  //localhost:3020/package/getChapterForPackages?packageId=5cd29d8eb36d8a74bbf9dc74&chapterIds=5ace20519fe7b01d5806cab6,5ace20519fe7b01d5806cab0&search=e
  .get(`/package/getChapterForPackages?packageId=${courseId}&chapterScope=${chaptersString}&search=${search}&isSubMilestones=${isSubMilestones}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const addMilestone = (courseId: string, parameters: any) => axiosNT
  .post(`/package/addMilestoneToPackage/${courseId}`, parameters)
  .then((res: any) => {
    const users = res;
    return Promise.resolve(users);
  });

const getAllGrade = () => axiosNTL
  .get(`/package/getGrades`)
  .then((res: any) => {
    const data = res.responseObject;
    return Promise.resolve(data);
  });

const getPackagePlan = (courseId: string) => axiosNTL
  .get(`/package/getPackagePlan/${courseId}`)
  .then((res: any) => {
    const data = res.responseObject || res.data;
    return Promise.resolve(data);
  });

const addSubMilestone = (courseId: string, parameters: any) => axiosNT
  .post(`/package/addSubMilestoneToPackage/${courseId}`, parameters)
  .then((res: any) => {
    return Promise.resolve(res);
  });

const addReviewMilestone = (courseId: string, parameters: any) => axiosNT
  .post(`/package/createRevisionMilestone/${courseId}`, parameters)
  .then((res: any) => {
    return Promise.resolve(res);
  });

const createCourse = (postData: any) => axios
  .post('/package/createPackage', postData)
  .then((res: any) => Promise.resolve(res.responseObject)
  );

const getAdmins = () => axiosNTL
  .get(`/user/getAdmins`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const getCourseTemplates = () => axiosNTL
  .get(`/package/getCourseTemplates`)
  .then((res: any) => {
    const users = res.responseObject || res.data;
    return Promise.resolve(users);
  });


const getMilestoneDetail = (courseId: string, milestoneId: string, ) => axiosNTL
  .get(`/package/getMilestoneDetail/${courseId}/${milestoneId}`)
  .then((res: any) => {
    const milestoneData = res.responseObject || res.data;
    return Promise.resolve(milestoneData);
  });


const publishPackage = (courseId: string) => axiosNT
  .patch(`/package/publishPackage/${courseId}`)
  .then((res: any) => {
    return Promise.resolve(res);
  });

const getSuggestedContent = (chapterId: string, type: string) => axiosNTL
  .get(`/package/getSuggestedContent?chapterId=${chapterId}&type=${type}`)
  .then((res: any) => {
    const milestoneData = res.responseObject || res.data;
    return Promise.resolve(milestoneData);
  });

const getChapterContent = (courseId: string, milestoneId: string, chapterId: string) => axiosNTL
  .get(`/package/getChapterContent/${courseId}/${milestoneId}/${chapterId}`)
  .then((res: any) => {
    const milestoneData = res.responseObject || res.data;
    return Promise.resolve(milestoneData);
  });
const getUsersWithGroups = () => axiosNT
  .get(`/userGroups/`)
  .then((res: any) => {
    return Promise.resolve(res);
  });

const shareCourseWithUser = (courseId: string, parameters: any) => axiosNT
  .post(`/package/share/${courseId}`, parameters)
  .then((res: any) => {
    return Promise.resolve(res);
  });

const addContentInChapter = (parameters: any) => axiosNT
  .patch(`/package/addContentInChapter`, parameters)
  .then((res: any) => {
    const addContentInChapterArr = res.responseObject || res.data;
    return Promise.resolve(addContentInChapterArr);
  });

const getGoalDriller = (paramValue: string, paramKey: string = 'chapterId') => axiosNTL
  .get(`/package/getGoalDriller?${paramKey}=${paramValue}`)
  .then((res: any) => {
    const drillerData = res.responseObject || res.data;
    return Promise.resolve(drillerData);
});

const getPackageDetails = (courseID: string) => axiosNT
  .get(`/package/getPackageBasicInfo/${courseID}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const unlockConcept = (parameters: any) => axiosNT
  .post(`/package/unlockTest`, parameters)
  .then((res: any) => {
    return Promise.resolve(res);
  });

const getMilestoneTestContent = (courseId: string, milestoneId: string) => axiosNTL
  .get(`/package/getMilestoneTestContent/${courseId}/${milestoneId}`)
  .then((res: any) => {
    const getMilestoneTestContentData = res.responseObject || res.data;
    return Promise.resolve(getMilestoneTestContentData);
  });

  const getSubMilestoneTestContent = (courseId: string, milestoneId: string,isSubmilestone:boolean) => axiosNTL
  .get(`/package/getMilestoneTestContent/${courseId}/${milestoneId}?submilestone=${isSubmilestone}`)
  .then((res: any) => {
    let getMilestoneTestContentData = {};
    if(res.responseObject!="Submilestone Not Found")
    {
       getMilestoneTestContentData = res.responseObject || res.data;
    }
    
    
    return Promise.resolve(getMilestoneTestContentData);
  });

const addMilestoneTest = (parameters: any) => axiosNT
  .post(`/package/addMilestoneTest`, parameters)
  .then((res: any) => {
    const addMilestoneTestData = res.responseObject || res.data;
    return Promise.resolve(addMilestoneTestData);
  });
  const addSubMilestoneTest = (parameters: any) => axiosNT
  .post(`/package/addSubMilestoneTest`, parameters)
  .then((res: any) => {
    const addMilestoneTestData = res.responseObject || res.data;
    return Promise.resolve(addMilestoneTestData);
  });
  
const copyCourse = (courseID: string) => axiosNTL
  .post(`/package/clone/${courseID}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });

const archiveCourse = (courseID: string) => axiosNTL
  .patch(`/package/archivePackage/${courseID}`)
  .then((res: any) => {
    const users = res.responseObject;
    return Promise.resolve(users);
  });
  
const deleteMilestone = (courseId: string, milestoneId: string) => axiosNT
  .delete(`/package/deleteMilestone/${courseId}/${milestoneId}`)
  .then((res: any) => {
    const deleteMilestoneResult = res.responseObject || res.data;
    return Promise.resolve(deleteMilestoneResult);
  });

const combineMilestone = (parameters: any) => axiosNT
  .put(`/package/combineMilestone`, parameters)
  .then((res: any) => {
    const combineMilestoneData = res.responseObject || res.data;
    return Promise.resolve(combineMilestoneData);
  });


const deleteContentfromSyllabus = (parameters: any) => axiosNT
  .post(`/package/deleteContentfromSyllabus`, parameters)
  .then((res: any) => {
    const deleteContentResult = res.responseObject || res.data;
    return Promise.resolve(deleteContentResult);
  });

const getContentDetails = (contentID: any) => axiosNT
  .get(`/content/getContentDetails/${contentID}`)
  .then((res: any) => {
    const deleteContentResult = res.responseObject || res.data;
    return Promise.resolve(deleteContentResult);
  });

  const editMilestone = (courseId: string, parameters: any) => axiosNT
  .put(`/package/editMilestone/${courseId}`, parameters)
  .then((res: any) => {
    return Promise.resolve(res);
  });
  const getSuggetedContentForMilestone = (packageId: string, milestoneId: string) => axiosNTL
  .get(`/package/getSuggetedContentForMilestone?packageId=${packageId}&milestoneId=${milestoneId}`)
  .then((res: any) => {
    const milestoneData = res.responseObject || res.data;
    return Promise.resolve(milestoneData);
  });

  const getPackageBasicInfo = (courseId: any) => axiosNT
    .get(`/package/getPackageBasicInfo/${courseId}`)
    .then((res: any)=>{
      const courseData = res.responseObject || res.data;
      return Promise.resolve(courseData);
    });
  const deleteSubmilestone = (parameters: any) => axiosNT
  .put(`/package/deleteSubmilestone`,parameters)
  .then((res: any)=>{
    const milestoneData = res.responseObject || res.data;
    return Promise.resolve(milestoneData);
  });

const scheduleTest = (postData: any) => axios.post('/package/scheduleTest', postData)
	.then((res: any) => Promise.resolve(res.responseObject));

const updateTestData = (postData:any) => axios.patch(`test/updateTest/${postData._id}`, postData)
	.then((res:any) => Promise.resolve(res.responseObject));

const fetchPackageList = (reqParams: any, courseRequestList?: boolean) => {
  const params=Object.keys(reqParams);
  let urlParams:string='';
  if(params.length>0){
     for(let i=0; i<params.length; i++){
       if(i==0){
         urlParams=`?${params[i]}=${reqParams[params[i]]}`;
       }else{
         urlParams=urlParams+`&${params[i]}=${reqParams[params[i]]}`
       }
     }
  }
  let courseUrl = '/package/v4';
  if (courseRequestList) {
    courseUrl += '/requests'
  }

  return axiosNTL
  .get(`${courseUrl}${urlParams}`)
  .then((res: any) => {
    if (courseRequestList && res.responseObject) {
      res.responseObject.packages = res.responseObject.packageChangeRequestList;
    } 
    return Promise.resolve( res.responseObject);
 })
};  

const fetchCenterList = () => {
  return axiosNTL
    .get('/package/v4/centers')
    .then((res: any) => {
      return Promise.resolve(res.responseObject);
    });
}

export default {
  getCourseData,
  getCourseDetail,
  copyCourse,
  getCourseChapters,
  addMilestone,
  getAllCourses,
  getAllGrade,
  getPackagePlan,
  addSubMilestone,
  addReviewMilestone,
  createCourse,
  getAdmins,
  getCourseTemplates,
  getMilestoneDetail,
  publishPackage,
  getSuggestedContent,
  getChapterContent,
  getUsersWithGroups,
  shareCourseWithUser,
  addContentInChapter,
  getPackageDetails,
  getGoalDriller,
  unlockConcept,
  addMilestoneTest,
  getMilestoneTestContent,
  deleteMilestone,
  combineMilestone,
  deleteContentfromSyllabus,
  getContentDetails,
  editMilestone,
  getSuggetedContentForMilestone,
  getPackageBasicInfo,
  getSubMilestoneTestContent,
  addSubMilestoneTest,
  deleteSubmilestone,
  archiveCourse,
	scheduleTest,
	updateTestData,
  fetchPackageList,
  getResponseSheet,
  fetchPackageListById: contentManagementService.getCourseData,
  fetchCenterList
};


